import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { bulkDeleteHard } from 'email-management-lib/EmailArchiveOrDelete/api/delete';
import { PROPERTIES } from 'email-management-lib/Shared/constants/frameworkTable';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { MatchTextArea } from 'foundations-components/transitional/components/MatchTextArea';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import Raven from 'raven-js';
import { useCallback, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function PermanentlyDeleteModal({
  crmObjects,
  onClose
}) {
  const [isDeleteDisabled, setIsDeleteDisabled] = useState(true);
  const count = crmObjects.length;
  const onDelete = useCallback(() => {
    const emailIds = crmObjects.map(crmObject => Number(getPropertyValue(crmObject, PROPERTIES.MARKETING_EMAIL_ID)));
    bulkDeleteHard(emailIds).then(() => {
      FloatingAlertStore.addAlert({
        message: I18n.text('email-management.emailDelete.permanently.alert.success', {
          count
        }),
        type: 'success'
      });
    }).catch(error => {
      Raven.captureException(new Error('Error when permanently deleting crmObjects'), {
        extra: {
          error: error.responseJSON || error
        }
      });
      FloatingAlertStore.addAlert({
        message: I18n.text('email-management.errors.email.permanentlyDelete', {
          count
        }),
        type: 'danger'
      });
    });
    onClose();
  }, [count, crmObjects, onClose]);
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "email-permanently-delete-modal",
    use: "danger",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.emailDelete.permanently.title",
          options: {
            count
          }
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        "data-test-id": "permanently-delete-modal-close",
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "email-management.emailDelete.permanently.body",
        options: {
          emailName: getPropertyValue(crmObjects[0], PROPERTIES.NAME),
          count
        }
      }), count > 1 && /*#__PURE__*/_jsx(View, {
        marginBlockStart: "400",
        children: /*#__PURE__*/_jsx(ExpandableText, {
          toggleable: false,
          scrollable: true,
          maxHeight: 200,
          children: /*#__PURE__*/_jsx(List, {
            styled: true,
            paddingInlineStart: "300",
            children: crmObjects.map(crmObject => /*#__PURE__*/_jsx(ListItem, {
              children: getPropertyValue(crmObject, PROPERTIES.NAME)
            }, crmObject.objectId))
          })
        })
      }), /*#__PURE__*/_jsx(View, {
        marginBlockStart: "400",
        children: /*#__PURE__*/_jsx(FormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "email-management.emailDelete.typeToDelete.label"
          }),
          children: /*#__PURE__*/_jsx(MatchTextArea, {
            match: I18n.text('email-management.emailDelete.typeToDelete.target'),
            onMatchedChange: () => setIsDeleteDisabled(false),
            size: "xxl"
          })
        })
      })]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsxs(ButtonWrapper, {
        children: [/*#__PURE__*/_jsx(Button, {
          disabled: isDeleteDisabled,
          onClick: onDelete,
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "email-management.emailDelete.confirm"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: onClose,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "email-management.emailDelete.cancel"
          })
        })]
      })
    })]
  });
}